import { useGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspense } from "api/generated/testing-activities/testing-activities";

export function useControlActivitiesSamplesQuery(controlId: string) {
    return useGetTestingActivitiesTestingActivityIdControlActivitiesSamplesSuspense(
        controlId,
        {
            query: {
                select: (response) => response.data,
            },
        }
    );
}
